var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiabetes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 65,
    fill: "#C9E2F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.8283 89.7402V101.147C86.8233 102.72 85.5367 103.995 83.9464 104C82.3593 103.988 81.0761 102.718 81.0645 101.147V89.7402H86.8266H86.8283Z",
    fill: "#3B97D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1375 35.5559C61.3325 30.1549 67.8285 26.9934 74.7129 27C85.1134 27 92.2883 35.6315 92.2883 45.7238C92.2883 57.8339 81.7334 70.5585 57.858 83.8565C57.4197 84.0964 56.8885 84.0964 56.4502 83.8565C32.5549 70.5585 22 57.8339 22 45.7238C22 35.6315 29.1683 27 39.5754 27C46.4548 26.9967 52.9441 30.1582 57.1358 35.5559H57.1375Z",
    fill: "#FF5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7622 47.0056C26.9671 47.0056 26.3213 46.3665 26.3213 45.5794C26.3213 38.6453 30.9911 31.2773 39.6468 31.2773C40.442 31.2773 41.0878 31.9165 41.0878 32.7036C41.0878 33.4907 40.442 34.1299 39.6468 34.1299C32.8637 34.1299 29.2015 40.0288 29.2015 45.5794C29.2015 46.3665 28.5558 47.0056 27.7606 47.0056H27.7622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.556 61.222C105.556 73.0346 95.8807 82.611 83.9463 82.611C72.0119 82.611 62.3369 73.0346 62.3369 61.222C62.3369 49.4093 72.0119 39.833 83.9463 39.833C95.8791 39.8379 105.551 49.411 105.556 61.222Z",
    fill: "#ECF0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.165 51.4679C94.8169 47.2335 84.6637 48.8142 78.03 55.3786C71.3979 61.943 69.8009 71.9942 74.079 80.2576C65.7586 76.038 61.1236 66.999 62.5928 57.8598C64.062 48.7205 71.3033 41.5531 80.5367 40.0989C89.7702 38.6447 98.9007 43.2324 103.165 51.4679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7089 81.8408V88.3149C89.7089 90.6777 87.7733 92.592 85.3877 92.592H82.5058C80.1186 92.592 78.1846 90.6761 78.1846 88.3149V81.8408C81.9563 82.8678 85.9372 82.8678 89.7089 81.8408Z",
    fill: "#95A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7865 62.8058C83.2039 62.8058 82.6793 62.4575 82.4552 61.9251C82.2327 61.3927 82.3555 60.7798 82.7672 60.3706L94.4526 48.8045C95.0187 48.2639 95.9168 48.2721 96.4713 48.8225C97.0258 49.373 97.0341 50.2619 96.4896 50.8206L84.8108 62.3868C84.5386 62.6563 84.17 62.8058 83.7865 62.8042V62.8058Z",
    fill: "#FF5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9458 45.5369C83.1507 45.5369 82.5049 44.8977 82.5049 44.1106V39.8335C82.5049 39.0464 83.1507 38.4072 83.9458 38.4072C84.741 38.4072 85.3868 39.0464 85.3868 39.8335V44.1106C85.3868 44.8977 84.741 45.5369 83.9458 45.5369Z",
    fill: "#3B97D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9458 84.0379C83.1507 84.0379 82.5049 83.3987 82.5049 82.6116V78.3345C82.5049 77.5474 83.1507 76.9082 83.9458 76.9082C84.741 76.9082 85.3868 77.5474 85.3868 78.3345V82.6116C85.3868 83.3987 84.741 84.0379 83.9458 84.0379Z",
    fill: "#3B97D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.555 62.6484H101.234C100.439 62.6484 99.793 62.0092 99.793 61.2222C99.793 60.4351 100.439 59.7959 101.234 59.7959H105.555C106.35 59.7959 106.996 60.4351 106.996 61.2222C106.996 62.0092 106.35 62.6484 105.555 62.6484Z",
    fill: "#3B97D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6596 62.6484H62.3384C61.5432 62.6484 60.8975 62.0092 60.8975 61.2222C60.8975 60.4351 61.5432 59.7959 62.3384 59.7959H66.6596C67.4548 59.7959 68.1006 60.4351 68.1006 61.2222C68.1006 62.0092 67.4548 62.6484 66.6596 62.6484Z",
    fill: "#3B97D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9462 84.0376C71.8292 84.0278 61.7922 74.7275 60.9854 62.7604C60.1786 50.7933 68.8759 40.2541 80.8833 38.6503C92.8907 37.0466 104.101 44.9239 106.528 56.6741C108.955 68.4244 101.771 80.0267 90.0902 83.2161C88.0881 83.7616 86.0213 84.0376 83.9445 84.0376H83.9462ZM83.9462 41.2597C72.807 41.2597 63.7777 50.1968 63.7777 61.2224C63.7777 72.248 72.807 81.1851 83.9462 81.1851C95.0854 81.1851 104.115 72.248 104.115 61.2224C104.103 50.2017 95.0804 41.2712 83.9462 41.2597Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9462 65.4996C86.3328 65.4996 88.2674 63.5846 88.2674 61.2225C88.2674 58.8603 86.3328 56.9453 83.9462 56.9453C81.5597 56.9453 79.625 58.8603 79.625 61.2225C79.625 63.5846 81.5597 65.4996 83.9462 65.4996Z",
    fill: "#BDC3C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 77,
    fill: "white",
    transform: "translate(22 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes);
export default __webpack_public_path__ + "static/media/Diabetes.1315e68406a0892c7eff629465ca3843.svg";
export { ForwardRef as ReactComponent };